import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Title, Meta, DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { StrapiService } from 'src/app/services/strapi.service';
import { environment } from '../../../../environments/environment';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.scss']
})
export class SearchResultsComponent implements OnInit {
  datas:any=[];searchTerm;
  messages: any[] = [];
  subscription: Subscription;
  categories:any=[];
  errores:string="";
  totalLength:any;
  page:number = 1;
  category:any;
  categorias:any=[];
  url: any;
  novedades: Object;
  id: string;
  constructor(
  	private title: Title,
    private meta: Meta,
    public strapiserv:StrapiService,
    private http: HttpClient,
    private domSanitizer: DomSanitizer,
    private _router:Router,
    private messageService: MessageService,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService
  ) {
    translate.addLangs(['es','en']);
     translate.setDefaultLang('es');
     this.subscription = this.messageService.onMessage().subscribe(message => {
         if (message) {
             this.messages.push(message);
             this.translate.setDefaultLang(message.text);
         } else {
             // clear messages when empty message received
             this.messages = [];
         }
     });
  }


  myCategories(datas: any){
     let newArr = [];
     let uniqueArray:any;
      datas.forEach((item, index) => {
        newArr.push(item.category.name);
        uniqueArray = newArr.filter(function(item, pos, self) {
          return self.indexOf(item)===pos;
        })


      });
      return uniqueArray;
  }


  ngOnInit(): void {
    this.url= this.domSanitizer.bypassSecurityTrustResourceUrl('https://blog-esource.daxosline.com.co/wordpress/');
  	this.title.setTitle('Blog');
    this.meta.updateTag({
      name: 'description',
      content: 'Publicaciones más relevantes del mundo cloud, transformación digital y el mundo empresarial'
    })
    this.meta.updateTag({
      name: 'keywords',
      content: 'Transformacion digital, Cloud, La nube, GCP, trabajo remoto, eSource capital, migración de datos, CSS, 2021, Navent, Google Cloud, Microsoft, Ciberseguridad'
    })


    this.strapiserv.getData().subscribe(res=>{

         //console.log('My '+ JSON.stringify(res[0].relevante));

     //   this.categories=this.myCategories(res);
        this.datas= res as string[];

        this.totalLength = res.length;


    }, error =>{
      console.log(error);
        if(error.status == 0){
            this.errores="Código del error: "+error.status+" \n Ha ocurrido un error del lado del cliente o un error de red.";
        }else{
            this.errores="Código del error: "+error.status+"\n\n"+error.statusText;
        }
    })

    this.http.get(`${environment.apiurl}posts?_embed&search=`+this.activatedRoute.snapshot.params.search+`&per_page=100`).subscribe(data =>{
      this.datas=data;
    })
    this.http.get(`${environment.apiurl}categories`).subscribe(data =>{
      this.categories=data;
    })//
    this.http.get(`${environment.apiurl}posts?category_slug=Novedades&per_page=3`).subscribe(data =>{
      this.novedades=data;
    })
  }


  filterRelevante(datas: any) : any {
      return datas.filter(data => data.relevante)

  }


  onPageChange(page:number){
    window.scrollTo(0,0);
  }
  testing(id:boolean){
    let value : string;
    id==true ? value="searchelement" : value="searchelement2";
    let data = (document.getElementById(value) as HTMLInputElement).value;
    data=='' ? null : this._router.navigate(['/search/'+data]);
    data=='' ? null : this.http.get(`${environment.apiurl}posts?_embed&search="`+data+`"&per_page=100`).subscribe(data =>{
      this.datas=data;
    })
  }
  searchCategory(id:any){
    this._router.navigate(['/categorias/'+id]);
    this.http.get(`${environment.apiurl}posts?_embed&categories=`+id+`&per_page=100`).subscribe(data =>{
    this.datas=data;
  })
}

}


